/**
 * IDs for the App container
 */
export enum AppId {
    LOADING_SPINNER = 'sails-loading-spinner',
    TEXT_HEADER = 'fixnet-text-header',
    ROUTER_IMAGE = 'fixnet-router-image',
    ROUTER_PICKER = 'fixnet-router-picker',
    BENEFIT_LIST = 'fixnet-router-benefits',
    OFFER_SUMMARY_CARD = 'fixnet-price-component',
    NON_BOOKABLE_CARD = 'fixnet-non-bookable-card-component',
    ACCORDION_ROUTER = 'fixnet-router-accordion',
    ACCORDION_FAQ = 'fixnet-faq-accordion',
    FOOTNOTE_ACCORDION = 'fixnet-footnote-accordion',
    APP_CONTAINER = 'fixnet-app-container',
    ERROR_CONTAINER = 'fixnet-error-container',
    AVC_ERROR_CONTAINER = 'fixnet-avc-error-container',
}

export enum CustomerInfoId {
    WRAPPER = 'fixnet-customer-info',
    CUSTOMER_NAME = 'fixnet-customer-name',
    CUSTOMER_CITY = 'fixnet-customer-city',
    CUSTOMER_STREET = 'fixnet-customer-street',
    CUSTOMER_NUMBER = 'fixnet-customer-number'
}

/**
 * Union type for all the available DOM IDs
 */
export type HtmlId = AppId;
